import React from 'react';
import { Icon } from './Icon.js';
export const IconGridCircleFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("circle", { cx: "9", cy: "3", r: "2.5", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" }),
        React.createElement("circle", { cx: "3", cy: "9", r: "2.5", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" }),
        React.createElement("circle", { cx: "3", cy: "3", r: "2.5", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("circle", { cx: "9", cy: "9", r: "2.5", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconGridCircleFill12.js.map